import { render, staticRenderFns } from "./ServicosAgendados.vue?vue&type=template&id=70ee084c"
import script from "./ServicosAgendados.vue?vue&type=script&lang=js"
export * from "./ServicosAgendados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports